<template>
  <wrap-container>
    <help-title title="Inversiones" />
    <help-list-container>
      <help-list-item tituloLista="Teléfonos útiles:">
        Estos son los teléfonos útiles o mail de contacto para que nuestros
        asesores especializados puedan ayudarte. Comunicate con nosotros al
        <strong>0810-666-4600</strong> de 9 a 18 hs o escribinos a
        <strong>inversiones-arg@bbva.com</strong>
      </help-list-item>

      <help-list-item tituloLista="Más información:">
        Encontrá más información sobre inversiones en nuestro sitio
        <custom-link
          label="Ver más Información"
          href="https://www.bbva.com.ar/personas/productos/inversiones.html"
        />
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import ContactLink from "@/components/core/ContactLink";
import CustomLink from "@/components/core/CustomLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink,
    ContactLink
  }
};
</script>
